import { mapGetters } from 'vuex';

import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import lazyCarouselCheckMixin from '@/common/mixins/lazycarouselcheck';
export default {
    name: 'dppBar',
    inject: ['$eventBus'],
    components: {
        mvtShifter,
    },
    mixins: [lazyCarouselCheckMixin],
    data() {
        return {
            componentMounted: false,
        };
    },
    watch: {
        getShowAgentsLink: function (newVal) {
            if (newVal) {
                this.$refs && this.$refs.agentPanelLink ? (this.$refs.agentPanelLink.style.display = 'block') : '';
            } else {
                this.$refs && this.$refs.agentPanelLink ? (this.$refs.agentPanelLink.style.display = 'none') : '';
            }
        },
    },
    mounted() {
        this.componentMounted = true;
    },
    computed: {
        ...mapGetters('glb', ['glb', 'isBrokerageArea', 'getSplit', 'hasAgent']),
        ...mapGetters('dpp', ['dpp', 'getPriceHistory', 'getLocalHighlight', 'getLocalHighlightScore', 'getHotleadLabel2']),
        highlights() {
            return this.getLocalHighlight && this.getLocalHighlight.sections;
        },
        showVeteran() {
            return !this.dpp.isRDC && !this.dpp.isRentals;
        },
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        hideHistory() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('hideHistory') >= 0;
        },
    }
};
